<div class="theme-toggle-container">
  <!-- Dropdown menu for theme selection -->
  <div class="theme-dropdown" [class.open]="isDropdownOpen">
    <button 
      class="theme-dropdown-btn" 
      (click)="toggleDropdown()"
      [attr.aria-label]="'Theme options'"
      title="Theme options">
      <span class="theme-icon">{{ getThemeIcon() }}</span>
      <span class="dropdown-arrow">▼</span>
    </button>
    
    <div class="theme-dropdown-menu">
      <button 
        class="theme-option" 
        [class.active]="currentTheme === 'light'"
        (click)="setTheme('light')">
        <span class="theme-icon">☀️</span>
        <span class="theme-label">Light Mode</span>
      </button>
      
      <button 
        class="theme-option" 
        [class.active]="currentTheme === 'dark'"
        (click)="setTheme('dark')">
        <span class="theme-icon">🌙</span>
        <span class="theme-label">Dark Mode</span>
      </button>
      
      <button 
        class="theme-option" 
        [class.active]="currentTheme === 'system'"
        (click)="setTheme('system')">
        <span class="theme-icon">⚙️</span>
        <span class="theme-label">System</span>
      </button>
    </div>
  </div>
</div>
